import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'

const useDivisionsForSelect = (divisionIds = [], hasExecutive = false) => {
  const [data, setData] = useState([])

  useEffect(() => {
    fetchDivisions(divisionIds)
  }, [])

  const fetchDivisions = useCallback(async () => {
    const url = hasExecutive ? '/divisions/for-select' : '/divisions/for-select-limited'
    let response = []
    if (divisionIds) {
      response = await axios.get(url, { params: { ids: divisionIds?.join(',') } })
    } else {
      response = await axios.get(url)
    }
    setData(response.data || [])
  }, [])

  return data
}

export default useDivisionsForSelect
